import { has } from "lodash";
import { DEFAULT_ERROR_MESSAGE } from "./consts";

export const getErrorMessage = (error: any) => {
  return has(error, "response.data.message")
    ? error.response.data.message
    : DEFAULT_ERROR_MESSAGE;
};
